<template>
  <div class="rt-grid">
    <div class="rt-grid-fixed" v-if="isNeedHeader">
      <div style="display: flex; flex-wrap: wrap; width: 100%">
        <div class="rt-grid__header">
          <div class="rt-grid__header_right">
            <template v-if="titleText">
              <el-breadcrumb>
                <el-breadcrumb-item v-for="(item, index) in views" :key="index">
                  <span style="color: #0050b3; font-size: 12px !important">{{
                    item
                  }}</span>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </template>
            <el-input
              v-if="needSearch"
              :placeholder="quicksearchPlaceholder"
              @keyup.enter.native="handleQuickSearch"
              v-model="quickSearch"
              :style="{
                width,
              }"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleQuickSearch"
                type="text"
                style="margin: -10px -19px"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div style="display: flex; width: 100%">
          <div
            style="width: 100%"
            id="grid__moresearch"
            class="rt-grid__moresearch"
            v-show="$slots.more"
          >
            <div style="display: flex; width: 100%">
              <slot name="more"></slot>
              <el-button
                v-if="noShow"
                type="primary"
                size="small"
                @click="handleSearch"
                >查询</el-button
              >
              <el-button
                v-if="noShow"
                plain
                size="small"
                @click="handleReset"
                class="rt-query__reset"
                >重置</el-button
              >
            </div>
          </div>
          <el-button
            v-if="$slots.more && noShow"
            type="text"
            @click="handleCollapse"
            class="operate"
          >
            <span>
              <span> {{ showHidden ? "收起" : "展开" }}&nbsp; </span>
              <i
                :class="showHidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></i>
            </span>
          </el-button>
        </div>
      </div>
      <rt-toolbar v-if="$slots.toolbar">
        <slot name="toolbar"></slot>
      </rt-toolbar>
    </div>
    <div class="rt-grid__body">
      <slot></slot>
    </div>
    <div class="rt-grid__footer">
      <el-pagination
        class="is-border"
        v-if="showPagination"
        @size-change="handleSizeChange"
        @current-change="handleIndexChange"
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="totalRecord"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "RtGrid",
  data() {
    return {
      quickSearch: null,
      showHidden: false,
      moreHeight: 0,
      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next, jumper",
      pageSizes: [5, 10, 20, 30, 40, 50],
      initPageIndex: false,
    };
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
    views: {
      type: Array,
      required: true,
    },
    quicksearchPlaceholder: String,
    showPagination: {
      type: Boolean,
      default: true,
      required: false,
    },
    totalRecord: {
      type: Number,
      required: false,
    },
    needSearch: {
      type: Boolean,
      default: true,
    },
    titleText: {
      type: Boolean,
      default: false,
    },
    noShow: {
      type: Boolean,
      default: true,
    },
    isNeedHeader: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    iconClass() {
      return this.showHidden ? "el-icon-arrow-up" : "el-icon-arrow-down";
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleCollapse() {
      this.showHidden = !this.showHidden;
      this.$nextTick(() => {
        var tableHeight = document.body.clientHeight - 270;
        var moreHeight =
          document.getElementById("grid__moresearch").clientHeight;

        this.$store.commit("UPDATE_TABLE_HEIGHT", tableHeight - moreHeight);
        this.$emit("getSearchHeight");
      });
    },
    handleReset() {
      this.$emit("reset");
    },
    handleSearch() {
      this.pageIndex = 1;
      this.$emit("search");
    },

    handleQuickSearch() {
      this.pageIndex = 1;
      this.$emit("quick-search");
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    handleIndexChange(val) {
      this.pageIndex = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    initChangePageIndex() {
      this.initPageIndex = true;
    },
    getPageIndex() {
      if (this.initPageIndex) {
        this.initPageIndex = false;
        return 1;
      } else {
        return this.pageIndex;
      }
    },
    getPageSize() {
      return this.pageSize;
    },
    setPageIndex(val) {
      this.pageIndex = val;
    },
    getSearchString() {
      return this.quickSearch;
    },
    setSearchString(quicksearch) {
      this.quickSearch = quicksearch;
    },
  },
};
</script>

<style lang="scss" scoped>
.rt-grid {
  .rt-toolbar {
    display: flex;
    margin-left: auto;
  }

  .rt-grid-fixed {
    display: flex;
    // position: fixed;
    left: 0;
    right: 0;
    z-index: 2000;
    top: 46px;
    margin: 0 16px;
    padding: 10px 24px 0px 24px;
    background-color: #fff;

    // .rt-grid__moresearch {
    //   display: block;
    // }

    & + .rt-grid__body {
      margin: 12px 16px 0;
      // height: calc(100% - 170px); //影响商机管理页面
      overflow: auto;
    }
  }

  .el-button--text {
    &.operate {
      padding: 0 !important;
      margin-left: 10px;
      color: #333 !important;
    }

    span {
      display: flex !important;
      align-items: center !important;
    }
  }
}

.grid-no-bar {
  .rt-grid-fixed {
    display: none;
  }
  .rt-grid__body {
    margin-top: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// main.vue?6431d682